<template>
  <div>
    <div class="dashboard-cards-grid">
      <!-- 1. Denúncias Não Triadas (Para Master) -->
      <b-card v-if="hasComplaintsModule && isMasterUser" no-body class="h-100">
        <b-card-body>
          <untriaged-complaints :company-id="company"></untriaged-complaints>
        </b-card-body>
      </b-card>

      <!-- 2. Denúncias Novas para Usuário (Para usuários master e usuários de empresa) -->
      <b-card
        v-if="hasComplaintsModule && showUnviewedComplaints"
        no-body
        class="h-100"
      >
        <b-card-body>
          <unviewed-complaints-for-user></unviewed-complaints-for-user>
        </b-card-body>
      </b-card>

      <!-- 3. Minhas Pendências (Apenas para Company-Root no grid) -->
      <b-card
        v-if="isCompanyRoot && type === 'complaint'"
        no-body
        class="h-100"
      >
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-tasks"></i>
            Minhas Pendências
          </h5>

          <div v-if="pendenciesLoading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="myPendencies.length === 0"
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma pendência encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="primary" class="mr-2">
                  Total: {{ myPendencies.length }}
                </b-badge>
                <small class="text-muted">pendências aguardando ação</small>
              </div>
            </div>

            <div class="notifications-list-container mt-0">
              <div class="notifications-header">
                <div class="row-content-pendency">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">PRAZO</div>
                  <div class="status-section header-label text-center">
                    STATUS
                  </div>
                  <div class="actions-section header-label text-center">
                    AÇÃO
                  </div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="event in myPendencies"
                    :key="event._id"
                    class="notification-row"
                    @click="openPendency(event)"
                  >
                    <div class="row-content-pendency">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          event.complaint.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span v-if="dueDate(event)" class="date-text">
                          {{ dueDate(event) | date }}
                        </span>
                        <span v-else class="text-muted">-</span>
                      </div>

                      <div class="status-section text-center">
                        <i
                          class="fas fa-calendar"
                          :class="getEventDueClass(event)"
                          :title="getEventDueTitle(event)"
                        />
                      </div>

                      <div class="actions-section text-center">
                        <b-button
                          size="sm"
                          variant="link"
                          class="p-0 action-button"
                          @click="showPendency($event, event)"
                        >
                          <i class="fas fa-eye"></i>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- 4. Demais Pendências (Apenas para Company-Root no grid) -->
      <b-card
        v-if="isCompanyRoot && type === 'complaint'"
        no-body
        class="h-100"
      >
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-users"></i>
            Demais Pendências
          </h5>

          <div v-if="pendenciesLoading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="otherPendencies.length === 0"
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma pendência encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="secondary" class="mr-2">
                  Total: {{ otherPendencies.length }}
                </b-badge>
                <small class="text-muted">pendências de outros usuários</small>
              </div>
            </div>

            <div class="notifications-list-container mt-0">
              <div class="notifications-header">
                <div class="row-content-pendency">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">PRAZO</div>
                  <div class="status-section header-label text-center">
                    STATUS
                  </div>
                  <div class="actions-section header-label text-center">
                    AÇÃO
                  </div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="event in otherPendencies"
                    :key="event._id"
                    class="notification-row"
                    @click="openPendency(event)"
                  >
                    <div class="row-content-pendency">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          event.complaint.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span v-if="dueDate(event)" class="date-text">
                          {{ dueDate(event) | date }}
                        </span>
                        <span v-else class="text-muted">-</span>
                      </div>

                      <div class="status-section text-center">
                        <i
                          class="fas fa-calendar"
                          :class="getEventDueClass(event)"
                          :title="getEventDueTitle(event)"
                        />
                      </div>

                      <div class="actions-section text-center">
                        <b-button
                          size="sm"
                          variant="link"
                          class="p-0 action-button"
                          @click="showPendency($event, event, true)"
                        >
                          <i class="fas fa-eye"></i>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Usuários Mencionados (Não Tratados) -->
      <b-card v-if="hasComplaintsModule && isMasterUser" no-body class="h-100">
        <b-card-body>
          <mentioned-users :company-id="company"></mentioned-users>
        </b-card-body>
      </b-card>

      <!-- Pendências Internas Atrasadas (Para Master) -->
      <b-card
        v-if="hasComplaintsModule && isMasterUser && profile.role !== 'root'"
        no-body
        class="h-100"
      >
        <b-card-body>
          <overdue-pendencies :company-id="company"></overdue-pendencies>
        </b-card-body>
      </b-card>

      <!-- Denúncias Paradas (Para Master ou Usuários de Empresa) -->
      <b-card
        v-if="hasComplaintsModule && showInactiveComplaintsCard"
        no-body
        class="h-100"
      >
        <b-card-body>
          <inactive-complaints :company-id="company"></inactive-complaints>
        </b-card-body>
      </b-card>

      <!-- Movimentações não visualizadas (Para todos exceto root) -->
      <b-card
        v-if="hasComplaintsModule && showMovementCard"
        no-body
        class="h-100"
      >
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-bell"></i>
            Movimentações não visualizadas
          </h5>

          <div v-if="loading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="
              filterNotifications(
                NotificationType.NEW_COMPLAINT_EVENT,
                NotificationType.NEW_RESPONSE
              ).length === 0
            "
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma movimentação não visualizada encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="secondary" class="mr-2">
                  Total:
                  {{
                    filterNotifications(
                      NotificationType.NEW_COMPLAINT_EVENT,
                      NotificationType.NEW_RESPONSE
                    ).length
                  }}
                </b-badge>
                <small class="text-muted"
                  >movimentações aguardando visualização</small
                >
              </div>
            </div>

            <div class="notifications-list-container">
              <div class="notifications-header">
                <div class="row-content">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">DATA DE CRIAÇÃO</div>
                  <div class="count-section header-label">QUANTIDADE</div>
                  <div class="actions-section header-label">AÇÃO</div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="notification in filterNotifications(
                      NotificationType.NEW_COMPLAINT_EVENT,
                      NotificationType.NEW_RESPONSE
                    )"
                    :key="notification._id"
                    class="notification-row"
                    @click="openNotification(notification)"
                  >
                    <div class="row-content">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          notification.complaint.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span class="date-text">{{
                          notification.createdAt | datetime
                        }}</span>
                      </div>

                      <div class="count-section">
                        <b-badge pill variant="secondary">{{
                          notification.count
                        }}</b-badge>
                      </div>

                      <div class="actions-section">
                        <i class="fas fa-external-link-alt action-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Denúncias não visualizadas pelo cliente (Apenas para Root) -->
      <b-card
        v-if="hasComplaintsModule && profile.role === 'root'"
        no-body
        class="h-100"
      >
        <b-card-body>
          <complaints-with-views :company-id="company"></complaints-with-views>
        </b-card-body>
      </b-card>

      <!-- Novas Dúvidas/Sugestões -->
      <b-card v-if="hasQaSModule" no-body class="h-100">
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-question-circle"></i>
            Novas Dúvidas/Sugestões ({{ qass.total }})
          </h5>

          <div v-if="loading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="qass.docs.length === 0"
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma nova dúvida/sugestão encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="primary" class="mr-2">
                  Total: {{ qass.total }}
                </b-badge>
                <small class="text-muted"
                  >dúvidas/sugestões aguardando análise</small
                >
              </div>
            </div>

            <div class="notifications-list-container">
              <div class="notifications-header">
                <div class="row-content">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">DATA DE CRIAÇÃO</div>
                  <div class="actions-section header-label">AÇÃO</div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="qas in qass.docs"
                    :key="qas._id"
                    class="notification-row"
                    @click="openQaS(qas)"
                  >
                    <div class="row-content">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          qas.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span class="date-text">{{
                          qas.createdAt | datetime
                        }}</span>
                      </div>

                      <div class="actions-section">
                        <i class="fas fa-external-link-alt action-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Novas Solicitações DSAR -->
      <b-card v-if="hasDSARModule" no-body class="h-100">
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-shield-alt"></i>
            Novas Solicitações DSAR
          </h5>

          <div v-if="loading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="
              filterNotifications(NotificationType.NEW_DSAR).length === 0
            "
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma nova solicitação DSAR encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="danger" class="mr-2">
                  Total:
                  {{ filterNotifications(NotificationType.NEW_DSAR).length }}
                </b-badge>
                <small class="text-muted"
                  >solicitações DSAR aguardando análise</small
                >
              </div>
            </div>

            <div class="notifications-list-container">
              <div class="notifications-header">
                <div class="row-content">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">DATA DE CRIAÇÃO</div>
                  <div class="count-section header-label">QUANTIDADE</div>
                  <div class="actions-section header-label">AÇÃO</div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="notification in filterNotifications(
                      NotificationType.NEW_DSAR
                    )"
                    :key="notification._id"
                    class="notification-row"
                    @click="openNotification(notification)"
                  >
                    <div class="row-content">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          notification.dsar.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span class="date-text">{{
                          notification.createdAt | datetime
                        }}</span>
                      </div>

                      <div class="count-section">
                        <b-badge pill variant="danger">{{
                          notification.count
                        }}</b-badge>
                      </div>

                      <div class="actions-section">
                        <i class="fas fa-external-link-alt action-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Movimentações DSAR não visualizadas -->
      <b-card v-if="hasDSARModule" no-body class="h-100">
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-bell"></i>
            Movimentações DSAR não visualizadas
          </h5>

          <div v-if="loading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="
              filterNotifications(
                NotificationType.NEW_DSAR_EVENT,
                NotificationType.NEW_RESPONSE
              ).length === 0
            "
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma movimentação DSAR não visualizada encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="secondary" class="mr-2">
                  Total:
                  {{
                    filterNotifications(
                      NotificationType.NEW_DSAR_EVENT,
                      NotificationType.NEW_RESPONSE
                    ).length
                  }}
                </b-badge>
                <small class="text-muted"
                  >movimentações DSAR aguardando visualização</small
                >
              </div>
            </div>

            <div class="notifications-list-container">
              <div class="notifications-header">
                <div class="row-content">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">DATA DE CRIAÇÃO</div>
                  <div class="count-section header-label">QUANTIDADE</div>
                  <div class="actions-section header-label">AÇÃO</div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="notification in filterNotifications(
                      NotificationType.NEW_DSAR_EVENT,
                      NotificationType.NEW_RESPONSE
                    )"
                    :key="notification._id"
                    class="notification-row"
                    @click="openNotification(notification)"
                  >
                    <div class="row-content">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          notification.dsar.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span class="date-text">{{
                          notification.createdAt | datetime
                        }}</span>
                      </div>

                      <div class="count-section">
                        <b-badge pill variant="secondary">{{
                          notification.count
                        }}</b-badge>
                      </div>

                      <div class="actions-section">
                        <i class="fas fa-external-link-alt action-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Novas Demandas Ouvidoria -->
      <b-card v-if="hasOmbudsmanModule" no-body class="h-100">
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-headset"></i>
            Novas Demandas Ouvidoria
          </h5>

          <div v-if="loading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="
              filterNotifications(NotificationType.NEW_OMBUDSMAN).length === 0
            "
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma nova demanda de ouvidoria encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="success" class="mr-2">
                  Total:
                  {{
                    filterNotifications(NotificationType.NEW_OMBUDSMAN).length
                  }}
                </b-badge>
                <small class="text-muted"
                  >demandas de ouvidoria aguardando análise</small
                >
              </div>
            </div>

            <div class="notifications-list-container">
              <div class="notifications-header">
                <div class="row-content">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">DATA DE CRIAÇÃO</div>
                  <div class="deadline-section header-label">PRAZO</div>
                  <div class="actions-section header-label">AÇÃO</div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="notification in filterNotifications(
                      NotificationType.NEW_OMBUDSMAN
                    )"
                    :key="notification._id"
                    class="notification-row"
                    @click="openNotification(notification)"
                  >
                    <div class="row-content">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          notification.ombudsman.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span class="date-text">{{
                          notification.createdAt | datetime
                        }}</span>
                      </div>

                      <div class="deadline-section">
                        <span class="deadline-text">{{
                          getOmbudsmanDeadline(notification) | datetime
                        }}</span>
                      </div>

                      <div class="actions-section">
                        <i class="fas fa-external-link-alt action-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <!-- Movimentações de Ouvidoria não visualizadas -->
      <b-card v-if="hasOmbudsmanModule" no-body class="h-100">
        <b-card-body>
          <h5 class="card-title">
            <i class="fas fa-bell"></i>
            Movimentações de Ouvidoria não visualizadas
          </h5>

          <div v-if="loading" class="text-center">
            <b-spinner small></b-spinner>
            <span class="ml-2">Carregando...</span>
          </div>
          <div
            v-else-if="
              filterNotifications(
                NotificationType.NEW_OMBUDSMAN_EVENT,
                NotificationType.NEW_RESPONSE
              ).length === 0
            "
            class="text-muted text-center"
          >
            <i class="fas fa-check-circle"></i>
            Nenhuma movimentação de ouvidoria não visualizada encontrada
          </div>
          <div v-else>
            <div class="mb-3">
              <div>
                <b-badge variant="secondary" class="mr-2">
                  Total:
                  {{
                    filterNotifications(
                      NotificationType.NEW_OMBUDSMAN_EVENT,
                      NotificationType.NEW_RESPONSE
                    ).length
                  }}
                </b-badge>
                <small class="text-muted"
                  >movimentações de ouvidoria aguardando visualização</small
                >
              </div>
            </div>

            <div class="notifications-list-container">
              <div class="notifications-header">
                <div class="row-content">
                  <div class="protocol-section header-label">PROTOCOLO</div>
                  <div class="date-section header-label">DATA DE CRIAÇÃO</div>
                  <div class="count-section header-label">QUANTIDADE</div>
                  <div class="actions-section header-label">AÇÃO</div>
                </div>
              </div>
              <div class="notifications-scroll">
                <div class="notifications-list">
                  <div
                    v-for="notification in filterNotifications(
                      NotificationType.NEW_OMBUDSMAN_EVENT,
                      NotificationType.NEW_RESPONSE
                    )"
                    :key="notification._id"
                    class="notification-row"
                    @click="openNotification(notification)"
                  >
                    <div class="row-content">
                      <div class="protocol-section">
                        <strong class="protocol-link">{{
                          notification.ombudsman.protocol
                        }}</strong>
                      </div>

                      <div class="date-section">
                        <span class="date-text">{{
                          notification.createdAt | datetime
                        }}</span>
                      </div>

                      <div class="count-section">
                        <b-badge pill variant="secondary">{{
                          notification.count
                        }}</b-badge>
                      </div>

                      <div class="actions-section">
                        <i class="fas fa-external-link-alt action-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>

    <!-- Modal para detalhes da pendência -->
    <b-modal
      ref="modal"
      :title="`Movimentação ${modalEvent.number}`"
      size="md"
      ok-only
    >
      <p class="card-text">
        <label><strong>Descrição:</strong></label> {{ modalEvent.description }}
      </p>
      <template
        v-if="modalEvent.pendency && modalEvent.pendency.user && showUser"
      >
        <label>
          <strong>Pendência para: </strong
          >{{ companyUsers[modalEvent.pendency.user].name }}
          {{ companyUsers[modalEvent.pendency.user].surname }}
        </label>
        <br />
      </template>
      <template v-if="modalEvent.task && modalEvent.task.email && showUser">
        <label>
          <strong>Tarefa de terceiros para: </strong>{{ modalEvent.task.email }}
        </label>
        <br />
      </template>
      <label v-if="modalEvent.pendency && modalEvent.pendency.dueDate">
        <strong>Prazo: </strong>{{ modalEvent.pendency.dueDate | date }}
      </label>
      <br />
      <p v-if="modalEvent.user" class="card-text">
        <small class="text-muted">
          <i class="fa fa-calendar-alt" aria-hidden="true"></i>
          {{ modalEvent.createdAt | datetime }} -
          <template v-if="companyUsers[modalEvent.user]">
            <i class="fa fa-user" aria-hidden="true"></i>
            {{ companyUsers[modalEvent.user].name }}
            {{ companyUsers[modalEvent.user].surname }}
          </template>
          <template v-else-if="conformitaUsers[modalEvent.user]">
            <i class="fa fa-user-tie text-info" aria-hidden="true"></i>
            {{ conformitaUsers[modalEvent.user].name }}
            {{ conformitaUsers[modalEvent.user].surname }}
          </template>
        </small>
      </p>
    </b-modal>
  </div>
</template>

<script>
import { getNotifications, markAsRead } from "../../api/notifications";
import { getPendencies } from "../../api/events";
import { getCompanyUsers } from "../../api/company";
import { getSystemUsers } from "../../api/user";
import NotificationType from "../../../../backend/models/NotificationType.ts";
import EventType from "../../../../backend/models/EventType.ts";
import UntriagedComplaints from "./charts/complaints/UntriagedComplaints";
import MentionedUsers from "./charts/complaints/MentionedUsers";
import InactiveComplaints from "./charts/complaints/InactiveComplaints";
import ComplaintsWithViews from "./charts/complaints/ComplaintsWithViews";
import OverduePendencies from "./charts/complaints/OverduePendencies";
import UnviewedComplaintsForUser from "./charts/complaints/UnviewedComplaintsForUser";
import { getQaSNotifications } from "../../api/qas";
import { mapGetters } from "vuex";
import { getDeadline } from "../ombudsman/ombudsman-utils";

export default {
  name: "ListNotifications",
  components: {
    UntriagedComplaints,
    MentionedUsers,
    InactiveComplaints,
    ComplaintsWithViews,
    OverduePendencies,
    UnviewedComplaintsForUser,
  },
  props: {
    company: {
      type: [Number, String],
      default: undefined,
    },
    type: {
      type: String,
      required: true,
    },
    showInactiveForUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notifications: [],
      qass: {
        total: 0,
        docs: [],
      },
      NotificationType,
      loading: true,
      myPendencies: [],
      otherPendencies: [],
      modalEvent: {
        pendency: {},
      },
      showUser: false,
      companyUsers: {},
      conformitaUsers: {},
      pendenciesLoading: false,
    };
  },
  computed: {
    ...mapGetters(["profile", "modules", "permissions"]),
    isMasterUser() {
      return (
        this.profile.role === "root" || this.profile.role === "company-root"
      );
    },
    isCompanyRoot() {
      return this.profile.role === "company-root";
    },
    showUnviewedComplaints() {
      // Mostrar para usuários master (company-root) e usuários de empresa (role numérico)
      // Não mostrar para root
      if (!this.profile || !this.profile.role) {
        return false;
      }
      if (this.profile.role === "root") {
        return false;
      }
      return true;
    },
    showInactiveComplaintsCard() {
      // Mostrar para usuários master e usuários de empresa
      // Não mostrar para root
      if (this.profile.role === "root") {
        return false;
      }
      return true;
    },
    showMovementCard() {
      // Mostrar para usuários master (company-root) e usuários de empresa
      // Não mostrar para root
      if (this.profile.role === "root") {
        return false;
      }
      return true;
    },
    hasComplaintsModule() {
      if (this.type !== "complaint") {
        return false;
      }
      if (this.isMasterUser) {
        return true;
      }
      if (!this.modules.complaint && this.modules.complaint.enabled) {
        return false;
      }
      if (parseInt(this.profile.role) === this.profile.role) {
        return (
          this.permissions.complaint &&
          (this.permissions.complaint.read ||
            this.permissions.complaint.readall)
        );
      }
      return true;
    },
    hasQaSModule() {
      if (this.type !== "qas") {
        return false;
      }
      if (this.isMasterUser) {
        return true;
      }
      if (!this.modules.qas && this.modules.qas.enabled) {
        return false;
      }
      if (parseInt(this.profile.role) === this.profile.role) {
        return this.permissions.qas && this.permissions.qas.read;
      }
      return true;
    },
    hasDSARModule() {
      if (this.type !== "dsar") {
        return false;
      }
      if (this.isMasterUser) {
        return true;
      }
      if (!this.modules.dsar && this.modules.dsar.enabled) {
        return false;
      }
      if (parseInt(this.profile.role) === this.profile.role) {
        return this.permissions.dsar && this.permissions.dsar.read;
      }
      return true;
    },
    hasOmbudsmanModule() {
      if (this.type !== "ombudsman") {
        return false;
      }
      if (this.isMasterUser) {
        return true;
      }
      if (!this.modules.ombudsman && this.modules.ombudsman.enabled) {
        return false;
      }
      if (parseInt(this.profile.role) === this.profile.role) {
        return this.permissions.ombudsman && this.permissions.ombudsman.read;
      }
      return true;
    },
    cols() {
      let items = 0;
      if (this.hasComplaintsModule) {
        items += 2;
      }
      if (this.hasQaSModule) {
        items++;
      }
      if (this.hasDSARModule) {
        items += 2;
      }
      if (this.hasOmbudsmanModule) {
        items += 2;
      }
      return 12 / items;
    },
  },
  async created() {
    this.loading = true;
    if (this.isCompanyRoot && this.type === "complaint") {
      this.fetchPendencies();
      this.loadUsers();
    }
    let response = await getNotifications(this.company, this.type);
    const notifications = response.data;

    const notificationsGrouped = {};

    for (const notification of notifications) {
      const gid = `${notification[this.type]._id}|${notification.type}`;
      notificationsGrouped[gid] = notificationsGrouped[gid] || [];
      notificationsGrouped[gid].push(notification);
    }
    const grouped = [];
    for (const gid of Object.keys(notificationsGrouped)) {
      const nots = notificationsGrouped[gid];
      nots.sort((a, b) => b._id - a._id);
      const first = nots[0];
      grouped.push({
        _id: first._id,
        type: first.type,
        createdAt: first.createdAt,
        complaint: first.complaint,
        dsar: first.dsar,
        ombudsman: first.ombudsman,
        count: nots.length,
      });
    }
    grouped.sort((a, b) => b._id - a._id);
    this.notifications = grouped;

    if (this.hasQaSModule) {
      response = await getQaSNotifications(this.company);
      this.qass = response.data;
    }
    this.loading = false;
  },
  methods: {
    filterNotifications(...types) {
      return this.notifications.filter((notification) =>
        types.includes(notification.type)
      );
    },
    getOmbudsmanDeadline(notification) {
      if (notification.ombudsman) {
        return getDeadline(notification.ombudsman);
      }
      return null;
    },
    async openNotification(notification) {
      markAsRead(notification);
      const routes = {
        complaint: "denuncias",
        dsar: "lgpd",
        ombudsman: "ouvidoria",
      };
      this.$router.push(`/${routes[this.type]}/${notification[this.type]._id}`);
    },
    async openQaS(qas) {
      this.$router.push(`/duvidas-e-sugestoes/${qas._id}`);
    },
    async fetchPendencies() {
      this.pendenciesLoading = true;
      try {
        let response = await getPendencies(this.company);
        let { myPendencies, otherPendencies } = response.data;

        const sortByDueDate = (a, b) => {
          const dateA = this.dueDate(a);
          const dateB = this.dueDate(b);

          if (!dateA && !dateB) return 0;
          if (!dateA) return 1;
          if (!dateB) return -1;

          return new Date(dateA) - new Date(dateB);
        };

        this.myPendencies = myPendencies.sort(sortByDueDate);
        this.otherPendencies = otherPendencies.sort(sortByDueDate);
      } catch (error) {
        console.error("Error fetching pendencies:", error);
      } finally {
        this.pendenciesLoading = false;
      }
    },
    async loadUsers() {
      try {
        let resp = await getCompanyUsers(this.profile.company);
        this.companyUsers = resp.data.reduce((obj, user) => {
          obj[user["_id"]] = user;
          return obj;
        }, {});

        resp = await getSystemUsers();
        this.conformitaUsers = resp.data.reduce((obj, user) => {
          obj[user["_id"]] = user;
          return obj;
        }, {});
      } catch (error) {
        console.error("Error loading users:", error);
      }
    },
    dueDate(event) {
      if (event.type === EventType.TASK) {
        return event.task.dueDate;
      }
      return event.pendency.dueDate;
    },
    async openPendency(event) {
      this.$router.push(`/denuncias/${event.complaint._id}?event=${event._id}`);
    },
    getEventDueClass(event) {
      const now = new Date().getTime() / 1000;
      const dueDate = new Date(this.dueDate(event)).getTime() / 1000;
      const delta = dueDate - now;

      if (delta < 0) {
        return "text-danger";
      } else if (delta <= 5 * 24 * 60 * 60) {
        return "text-warning";
      } else {
        return "text-success";
      }
    },
    getEventDueTitle(event) {
      const now = new Date().getTime() / 1000;
      const dueDate = new Date(this.dueDate(event)).getTime() / 1000;
      const delta = dueDate - now;

      if (delta < 0) {
        return "Vencida";
      } else if (delta <= 5 * 24 * 60 * 60) {
        return "Vence em menos de 5 dias";
      } else {
        return "À vencer";
      }
    },
    showPendency(evt, pendency, showUser = false) {
      evt.stopPropagation();
      this.modalEvent = pendency;
      this.showUser = showUser;
      this.$refs.modal.show();
    },
  },
};
</script>

<style scoped>
.dashboard-cards-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

@media (max-width: 991px) {
  .dashboard-cards-grid {
    grid-template-columns: 1fr;
  }
}

.h-100 {
  height: 100% !important;
}

.notifications-list-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  margin-top: 1rem;
}

.notifications-header {
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.header-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.notifications-scroll {
  max-height: 250px;
  overflow-y: auto;
}

.notifications-list {
  padding: 0;
}

.notification-row {
  border-bottom: 1px solid #f1f3f4;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.notification-row:hover {
  background-color: #f8f9fa;
}

.notification-row:last-child {
  border-bottom: none;
}

.row-content {
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 0.5fr;
  align-items: center;
  gap: 1rem;
}

.row-content-pendency {
  display: grid;
  grid-template-columns: 2fr 1.5fr 0.8fr 0.5fr;
  align-items: center;
  gap: 1rem;
}

.protocol-section,
.date-section,
.count-section,
.deadline-section,
.actions-section {
  display: flex;
  align-items: center;
}

.actions-section {
  justify-content: center;
}

.protocol-link {
  color: #007bff;
  font-weight: 500;
}

.date-text,
.deadline-text {
  color: #6c757d;
}

.action-icon {
  color: #6c757d;
  transition: color 0.2s;
}

.notification-row:hover .action-icon {
  color: #007bff;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #495057;
}

.card-title .fas {
  margin-right: 8px;
}

.card-title .fa-exclamation-triangle {
  color: #ffc107;
}

.card-title .fa-at {
  color: #17a2b8;
}

.card-title .fa-bell {
  color: #6c757d;
}

.card-title .fa-tasks {
  color: #007bff;
}

.card-title .fa-users {
  color: #6c757d;
}

.card-title .fa-question-circle {
  color: #007bff;
}

.card-title .fa-shield-alt {
  color: #dc3545;
}

.card-title .fa-headset {
  color: #28a745;
}

/* Ajustes para os cards */
.card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 1.5rem;
}

/* Responsividade */
@media (max-width: 992px) {
  .row-content {
    grid-template-columns: 1.5fr 1fr 0.8fr 0.5fr;
    gap: 0.5rem;
  }

  .header-label {
    font-size: 0.7rem;
  }
}
</style>
